import { useStepNavigate } from "../hooks/useStepNavigate";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";

const VoltMegrendeles = () => {
	const navigate = useStepNavigate();

	const handleBackClick = () => {
		navigate("/RendelesTipus");
	};

	return (
		<TablerLayout title="Volt már korábban megrendelése nálunk?">
			<div className="row justify-content-center">
				<div className="col-md-10 text-center mb-4">
					<div className="d-flex flex-column flex-md-row justify-content-center gap-4">
						<button type="button" className="btn btn-outline-primary w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold" style={{ minWidth: 180, fontSize: 22 }} onClick={() => navigate("/Adat")}>
							Nem
						</button>
						<button type="button" className="btn btn-primary w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold" style={{ minWidth: 180, fontSize: 22 }} onClick={() => navigate("/Taj")}>
							Igen
						</button>
					</div>
				</div>
			</div>
			<StepperNavButton side="left" label="Vissza" onClick={handleBackClick} />
		</TablerLayout>
	);
};

export default VoltMegrendeles;
